import { z } from 'zod';

import { BlockValueFieldSchemaV2, BlockValueFieldSchemaVariant } from './blockValueFieldSchema.js';
import { BlockValueTemplateHint, validateBlockValueTemplate } from './template.js';

/**
 * @arg stringValidationSchema - User supplied zod string schema that is checked if value is not a block
 * value template. e.g. `z.string().maxLength(20)`
 * @returns A Zod schema for validating values that are either block value templates or some zod string type.
 */
export function BlockValueStringSchema(args: { stringValidationSchema: z.ZodType<string> }) {
  return z.coerce.string().superRefine((stringValue, context) => {
    const templateParseResult = BlockValueFieldSchemaV2({
      variant: BlockValueFieldSchemaVariant.TemplateOnly,
    }).safeParse(stringValue);
    if (templateParseResult.success) {
      return;
    }
    // We want to validate against string schema only if string is not template-like
    const templateValidation = validateBlockValueTemplate(stringValue);
    if (templateValidation.hint !== BlockValueTemplateHint.NotTemplateLike) {
      templateParseResult.error.issues.forEach((issue) => {
        context.addIssue(issue as Parameters<typeof context.addIssue>[0]);
      });
      return;
    }
    const stringParseResult = args.stringValidationSchema.safeParse(stringValue);
    if (stringParseResult.success) {
      return;
    }
    stringParseResult.error.issues.forEach((issue) => {
      context.addIssue(issue as Parameters<typeof context.addIssue>[0]);
    });
    templateParseResult.error.issues.forEach((issue) => {
      context.addIssue(issue as Parameters<typeof context.addIssue>[0]);
    });
  });
}
